const trains = {
  train: "รถไฟ", // translated
  trains: "รถไฟ", // translated
  fairConditions: "เงื่อนไขที่เป็นธรรม", // translated
  to: "ถึง", // translated
  earlier: "ก่อนหน้านี้", // translated
  later: "ภายหลัง", // translated
  adults: "ผู้ใหญ่", // translated
  child: "เด็ก", // translated
  senior: "อาวุโส", // translated
  seniors: "ผู้สูงอายุ", // translated
  price: "ราคา", // translated
  for: "สำหรับ", // translated
  total: "ทั้งหมด", // translated
  selected: "เลือกแล้ว", // translated
  prebook: "จองล่วงหน้า", // translated
  book: "หนังสือ", // translated
  payment: "การชำระเงิน", // translated
  return: "กลับ", // translated
  passengers: "ผู้โดยสาร", // translated
  delivery: "จัดส่ง", // translated
  summary: "สรุป", // translated
  checkout: "เช็คเอาท์", // translated
  trainToastCorrectFillForm: "กรุณากรอกข้อมูลให้ครบทุกช่อง", // translated
  fareConditions: "เงื่อนไขค่าโดยสาร", // translated
  travelInfo: "ข้อมูลการเดินทาง", // translated
  remarks: "หมายเหตุของลูกค้า", // translated
  noServices: "ไม่มีบริการ", // translated
  timesAndSeats: "เวลาและที่นั่ง", // translated
  mobileTicket: "ตั๋วมือถือ", // translated
  stationTicket: "มารับที่สถานี", // translated
  homeTicket: "พิมพ์ที่บ้าน", // translated
  countryCode: "รหัสประเทศ", // translated
  chooseTicket: "เลือกวิธีการจัดส่งตั๋ว", // translated
  ticketError: "โปรดเลือกตั๋วสำหรับทุกจุดหมายปลายทาง", // translated
  ticketDelivery: "กรุณาเลือกวิธีการจัดส่งตั๋ว", // translated
  passengerDetails: "รายละเอียดผู้โดยสาร", // translated
  waitWhileProcessingPayment: "โปรดรอในขณะที่เราประมวลผลการชำระเงินของคุณ อย่ารีเฟรชหรือปิดหน้านี้", // translated
  reductionCardId: "รหัสบัตรส่วนลด", // translated
  countryOfResidence: "ประเทศที่พำนัก", // translated
  countryOfBirth: "ประเทศที่เกิด", // translated
  documentCountry: "ประเทศของเอกสาร", // translated
  documentNumber: "หมายเลขเอกสาร", // translated
  expirationDate: "วันหมดอายุ", // translated
  documentType: "ประเภทเอกสาร", // translated
  travelerDocumentInfo: "ข้อมูลเอกสารการเดินทาง", // translated
  youth: "ความเยาว์", // translated
  youths: "เยาวชน", // translated
  departTimeEarlyFirst: "เวลาออกเดินทาง (เร็วที่สุดก่อน)", // translated
};

export default trains;
